import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Row } from 'antd';
import { browserHistory } from 'react-router';

import { queryDepartmentProduct, querySaveDepartmentProduct } from '@api/crm/crm';
import { goBack } from '@comm/BackBtn';

const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: [{ key: 0 }],
    };
  }

  componentDidMount() {
    this.getData();
  }

  submit = e => {
    e.preventDefault();
    const { config } = this.state;
    this.props.form.validateFields(err => {
      if (!err) {
        const params = {
          uuid: this.props.params.uuid,
          config,
        };
        this.postData(params);
      }
    });
  };

  getData = () => {
    queryDepartmentProduct({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200 && res.data) {
        res.data.map((item, index) => {
          item.key = index;
          return item;
        });
        this.setState({
          config: res.data,
        });
      }
    });
  };

  postData = params => {
    querySaveDepartmentProduct(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  addConfig = () => {
    const { config } = this.state;
    const key = config[config.length - 1].key + 1;
    this.setState({
      config: [...config, { key }],
    });
  };

  subConfig = key => {
    const { config } = this.state;
    const configArr = config.filter(item => {
      return item.key !== key;
    });
    this.setState({
      config: configArr,
    });
  };

  handleChange = (type, index) => {
    return e => {
      const { config } = this.state;
      config[index][type] = e.target.value;

      this.setState({
        config,
      });
    };
  };

  render() {
    const { config } = this.state;
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const { getFieldDecorator } = this.props.form;

    return (
      <Card title="阶段设置">
        <Form onSubmit={this.submit} className="">
          {config.map((item, index) => {
            return (
              <Row key={item.key}>
                <Col span={6}>
                  <FormItem label="产品名称" {...ItemLayout}>
                    {getFieldDecorator(`name${item.key}`, {
                      rules: [{ required: true, message: '请填写产品名称!' }],
                      initialValue: item.name,
                    })(<Input onChange={this.handleChange('name', index)} />)}
                  </FormItem>
                </Col>
                <Col span={5}>
                  <FormItem style={{ textAlign: 'right' }}>
                    {config.length - 1 === index ? (
                      <Button type="primary" onClick={this.addConfig} style={{ marginRight: 10 }}>
                        +
                      </Button>
                    ) : null}
                    {config.length === 1 ? null : (
                      <Button onClick={() => this.subConfig(item.key)}>-</Button>
                    )}
                  </FormItem>
                </Col>
              </Row>
            );
          })}
          <Row>
            <Col span={24} style={{ marginBottom: 15, textAlign: 'right' }}>
              <Button style={{ marginRight: 10 }} type="primary" htmlType="submit">
                确定
              </Button>
              <Button onClick={goBack}>取消</Button>
            </Col>
          </Row>
        </Form>
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/department/PageSetProject.js